import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ErrorHandlingService} from '../error/error-handling.service';
import {Router} from "@angular/router";
import {AuthService} from "../http/auth/auth.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private errorHandler: ErrorHandlingService,
              private router: Router,
              private authService: AuthService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        switch (error.status) {
          case 401:
            this.authService.login();
            break;
          case 403:
            this.router.navigate(['forbidden']);
            break;
          default:
            this.errorHandler.handleError(error);
        }
        return throwError(error);
      })
    )
  }
}
